import React from 'react';
import { Advertorial } from './components/Advertorial';
import { MetaPixel } from './components/MetaPixel';
import { HotjarTracking } from './components/HotjarTracking';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  return <div className="w-full bg-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HotjarTracking data-id="element-2" />
      <GoogleTagManager data-id="element-3" />
      <Advertorial data-id="element-4" />
    </div>;
}